import React, {useState} from 'react';
import LineChart from '../../../component/Inc/LineChart';
import 'contents/assets/scss/page/mypage.scss';
import ImgProfile from 'contents/assets/img/@profile.png';
import PopSaleGoal from '../_PopSaleGoal';
import PopChatting from '../_PopChatting';
function ClassTeacher() {
  const [modalChattingOpen, setModalChattingOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isOrderActive1, setIsOrderActive1] = useState(false);
  const [isOrderActive2, setIsOrderActive2] = useState(false);
  const [isOrderActive3, setIsOrderActive3] = useState(false);

  const lineChartWidth = '100%';
  const lineChartHeight = '147px';
  const labels = ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
  const data = {
    lineChartlabels: labels,
    datasets: [
      {
        label: '목표',
        data: [10000, 20000, 40000, 20000, 50000, 20000, 30000, 10000, 20000, 40000, 20000, 50000, 20000, 30000],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#fc8019'
      },
      {
        label: '매출',
        data: [20000, 50000, 30000, 10000, 10000, 20000, 20000, 20000, 60000, 50000, 40000, 20000, 60000, 40000],
        fill: false,
        borderColor: '#d1cdca',
        borderWidth: 1,
        backgroundColor: '#3780ff'
      }
    ]
  };
  return (
    <main className="com_container com_teacher">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu12_1">김담임507 담임</h2>
        </section>
        <section className="com_pg_container">
          {/* 수업정보 */}
          <section className="box box-1">
            <div className="detail_tit dot">수업정보</div>
            <div className="com_status_box">
              <div className="item">
                <p className="tit">담당 학생</p>
                <p className="num">4030</p>
              </div>
              <div className="item">
                <p className="tit">진행 수업 / 타임 수</p>
                <p className="num">7800 / 9004</p>
              </div>
              <div className="item blue">
                <p className="tit">12월 매출</p>
                <p className="num">785,056</p>
              </div>
              <div className="item">
                <p className="tit">12월 목표 매출</p>
                <p className="num">
                  <button onClick={() => setModalOpen(true)} className="com_btn gray xxs">
                    수정
                  </button>
                  840,000
                </p>
              </div>
            </div>
            <div className="detail_tit dot">월간 평균 매출</div>
            <LineChart data={data} width={lineChartWidth} height={lineChartHeight} />
          </section>
          {/* 담당 학생 */}
          <section className="box">
            <div className="detail_tit dot">담당 학생 (50)</div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="25%" />
                  <col width="30%" />
                  <col width="30%" />
                  <col width="20%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>
                      <button
                        onClick={() => {
                          setIsOrderActive1(!isOrderActive1);
                        }}
                        className={`arrow ${isOrderActive1 ? `active` : ``}`}
                      />
                      학생명
                    </th>
                    <th>과목</th>
                    <th>
                      <button
                        onClick={() => {
                          setIsOrderActive2(!isOrderActive2);
                        }}
                        className={`arrow ${isOrderActive2 ? `active` : ``}`}
                      />
                      진행수업 수
                    </th>
                    <th>
                      <button
                        onClick={() => {
                          setIsOrderActive3(!isOrderActive3);
                        }}
                        className={`arrow ${isOrderActive3 ? `active` : ``}`}
                      />
                      교사명
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>
                          <button className="name btn_link">김길동111</button>
                        </td>
                        <td>사탐</td>
                        <td>45</td>
                        <td>
                          <button className="name btn_link">김교사111</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="com_btn_wrap right">
              <button className="com_btn red xs">수업대기 : 58명</button>
              <button className="com_btn orange xs btn_plus">학생 추가</button>
            </div>
          </section>
          {/* 시범강의 수업 요청 */}
          <section className="box">
            <div className="detail_tit dot">시범강의 수업 요청</div>
            <div className="notice_box orange">홍담임103님 앞으로 새로운 ‘시범강의’ 요청이 왔습니다.</div>
            <div className="com_board_list__scroll">
              <table className="com_board_list">
                <colgroup>
                  <col width="25%" />
                  <col width="22%" />
                  <col width="28%" />
                  <col width="28%" />
                </colgroup>
                <thead>
                  <tr>
                    <th>홍보자</th>
                    <th>학생명</th>
                    <th>전화번호</th>
                    <th>강의요청 일시</th>
                  </tr>
                </thead>
                <tbody>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                    return (
                      <tr key={idx}>
                        <td>
                          <button className="name btn_link">김길동111</button>
                        </td>
                        <td>김학생</td>
                        <td>010-2323-2222</td>
                        <td>2023.03.04 18:40</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </section>
          <div className="box_wrap">
            <div className="left">
              {/* 결제 알림 */}
              <section className="box box-2 sec_pay_notice">
                <div className="detail_tit dot ">결제 알림</div>
                <div className="com_board_list__scroll">
                  <table className="com_board_list">
                    <colgroup>
                      <col width="13%" />
                      <col width="13%" />
                      <col width="13%" />
                      <col />
                      <col width="13%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>등록일</th>
                        <th>등록자</th>
                        <th>내용</th>
                        <th>제목</th>
                        <th>이동</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                        return (
                          <tr key={idx}>
                            <td>2023.05.10 14:30</td>
                            <td>
                              <button className="name btn_link">김길동111</button>
                            </td>
                            <td>첫수업 보고서</td>
                            <td>안녕하세요. 결제일입니다.</td>
                            <td>
                              <button className="name btn_link blue">이동하기</button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </section>

              {/* 받은 메일 */}
              <section className="box sec_mail">
                <div className="detail_tit dot ">
                  받은 메일
                  <button className="com_btn orange xs btn_mail_send">메일 보내기</button>
                </div>
                <div className="com_board_list__scroll">
                  <table className="com_board_list">
                    <colgroup>
                      <col width="25%" />
                      <col width="25%" />
                      <col width="50%" />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>보낸사람</th>
                        <th>날짜</th>
                        <th>메일 제목</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                        return (
                          <tr key={idx}>
                            <td>김학생103</td>
                            <td className="td_date">2022.08.25</td>
                            <td className="td_left">
                              <p className="memo">안녕하세요 금일 일정이 있습니다</p>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </section>
            </div>

            {/* 채팅 목록 */}
            <section className="box box-1">
              <div className="detail_tit dot ">채팅 목록</div>
              <ul className="chat_list">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i, idx) => {
                  return (
                    <li onClick={() => setModalChattingOpen(true)} className="item" key={idx}>
                      <p className="thumb">
                        <img src={ImgProfile} alt="profile" />
                      </p>
                      <div className="info_box">
                        <p className="name">홍길동103 (영어)</p>
                        <p className="desc">안녕하세요 12월에 입사한 이주영입니다. 미래를 만드는 이지와 함께 성장하고 싶습니다~~~~~</p>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </section>
          </div>
        </section>
      </div>
      <PopSaleGoal open={modalOpen} close={() => setModalOpen(false)} />
      <PopChatting open={modalChattingOpen} close={() => setModalChattingOpen(false)} />
    </main>
  );
}

export default ClassTeacher;
